<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {

        }
    },
    created() {
    },
    methods: {
    
    }
}
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue